import React from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <button className="modal-close" onClick={onClose} aria-label="Chiudi modal">
          ×
        </button>
        
        <div className="modal-header">
          <div className="modal-icon">🚧</div>
          <h2 className="modal-title">Prodotto in Sviluppo</h2>
        </div>
        
        <div className="modal-body">
          <p className="modal-description">
            Il nostro antivirus <strong>ZeroInfezioni</strong> è attualmente in fase di sviluppo 
            e sarà disponibile molto presto.
          </p>
          
          <div className="modal-features">
            <div className="modal-feature">
              <span className="feature-icon">⏰</span>
              <span>Lancio previsto: Q4 2025</span>
            </div>
            <div className="modal-feature">
              <span className="feature-icon">🔔</span>
              <span>Ti avviseremo appena sarà pronto</span>
            </div>
            <div className="modal-feature">
              <span className="feature-icon">🎯</span>
              <span>100% Made in Italy</span>
            </div>
          </div>
          
          <p className="modal-note">
            Vuoi essere tra i primi a provare ZeroInfezioni? 
            Contattaci per ricevere l'accesso anticipato.
          </p>
        </div>
        
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onClose}>
            Ho Capito
          </button>
          <a href="#contatti" className="btn btn-outline" onClick={onClose}>
            Contattaci
          </a>
        </div>
      </div>
    </div>
  );
};

export default Modal; 